<div *ngIf="session && session.belongsToUser && !showProgress">
  <button igxButton="outlined" (click)="startSession()">
    <span *ngIf="session.status === 'Not Started'">Start</span>
    <span *ngIf="session.status === 'In Progress'">Resume</span>
  </button>
</div>

<div *ngIf="showProgress" class="progress">
  <igx-circular-bar [indeterminate]="true"></igx-circular-bar>
</div>